import script from "./MarkdownContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./MarkdownContent.vue?vue&type=script&setup=true&lang=ts"

import "./MarkdownContent.vue?vue&type=style&index=0&id=6289aaf0&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6289aaf0"]])

export default __exports__